var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4593 16.5153C18.8198 16.9308 19 17.1385 19 17.5C19 17.8615 18.8198 18.0692 18.4593 18.4847C17.5612 19.5199 15.9381 21 14 21C12.0619 21 10.4388 19.5199 9.54069 18.4847C9.18023 18.0692 9 17.8615 9 17.5C9 17.1385 9.18023 16.9308 9.54069 16.5153C10.4388 15.4801 12.0619 14 14 14C15.9381 14 17.5612 15.4801 18.4593 16.5153Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.0032V6.81989C18 5.12616 18 4.27928 17.732 3.60291C17.3012 2.51554 16.3902 1.65784 15.2352 1.25228C14.5168 1 13.6173 1 11.8182 1C8.66981 1 7.09563 1 5.83836 1.44148C3.81714 2.15122 2.22281 3.6522 1.46894 5.55509C1 6.73875 1 8.22077 1 11.1848V13.731C1 16.8013 1 18.3364 1.8477 19.4025C2.09058 19.708 2.37862 19.9792 2.70307 20.2078C3.61506 20.8506 4.85019 20.9757 7 21",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11C1 9.15905 2.49238 7.66667 4.33333 7.66667C4.99912 7.66667 5.78404 7.78333 6.43137 7.60988C7.00652 7.45576 7.45576 7.00652 7.60988 6.43136C7.78333 5.78404 7.66667 4.99912 7.66667 4.33333C7.66667 2.49238 9.15905 1 11 1",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 17.5H14.0012",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileView);
export default __webpack_public_path__ + "static/media/file-view.d73bf0655eaf1af77f13297ad08ce35e.svg";
export { ForwardRef as ReactComponent };